module.exports = __webpack_public_path__ + "img/iconYeWuShuiFenJianCe.a71686a8.svg";